<template>
<div>

    <!--充值弹框界面-->
    <el-dialog title="批量充值信息" :visible.sync="isrecharge" width="60%" :close-on-click-modal="false">
        <el-row>
            <el-col :span="24">
                <!--列表(查询结果-当前页)row-style="height:12px;"-->
                <el-table :data="bathRechargeInfo" highlight-current-row v-loading="listLoading" style="width: 100%;line-height:22px;" height="450" border >
                    <el-table-column prop="msisdn" label="卡号" width="130" sortable>
                    </el-table-column>
                    <el-table-column prop="iccid" label="ICCID" width="180">
                    </el-table-column>
                    <el-table-column prop="packagename" label="套餐名称" min-width="180">
                    </el-table-column>
                    <el-table-column prop="rechargePrice" label="套餐金额" min-width="80">
                    </el-table-column>
                    <el-table-column prop="arreas" label="欠费金额" min-width="80">
                    </el-table-column>
                    <el-table-column prop="money" label="应缴金额" min-width="80">
                    </el-table-column>
                    <el-table-column prop="expireTime" label="当前到期时间" min-width="120">
                    </el-table-column>
                    <el-table-column prop="rechargeExpireTime" label="预计到期时间" min-width="120">
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row style="line-height:32px;margin-top:15px;">
            <!--工具条(分页)-->
            <el-col :span="12">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="total" style="padding-top:2px;">
                </el-pagination>
            </el-col>
        </el-row>
        <el-row style="line-height:32px;margin-top:15px;">
            <el-col :span="8">
                <el-select v-model="rechargemonth" @change="rechargemonthchange" placeholder="续费时长" style="width:150px;margin-top:-5px;">
                    <el-option v-for="item in options_month" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <span style="color:red;margin-left:5px;"><i class="el-icon-warning-outline"></i>续费时长</span>
            </el-col>
            <el-col :span="10">
                <div style="font-weight:bold;">本次共充值：<span style="color:red;font-size:17px"> {{this.total}} </span>张卡，总金额：<span style="color:red;font-size:17px"> {{this.rechargePrice}} </span>元 </div>
            </el-col>
            <el-col :span="6" style="text-align:right;">
                <el-button type="primary" size="small" @click.native="exportRechage()">&nbsp;&nbsp;&nbsp;导 出&nbsp;&nbsp;&nbsp;</el-button>
                <el-button type="primary" size="small" @click.native="toRecharge()">立即充值</el-button>
            </el-col>
        </el-row>
    </el-dialog>

    <!--批量编辑卡号界面-->
    <el-form :model="addForm" label-width="0px" ref="addForm">
        <el-form-item label="">
            <input type="file" @change="onFileChange" v-show="false" ref="excelFileHook" accept=".xls,.xlsx">
            <el-col :span="24" class="toolbar">
                <el-button type="primary" icon="el-icon-upload" @click.native="choiseFile">上传模板文件</el-button>
            </el-col>
            <div class="el-upload__tip">
                <el-col :span="12">
                    支持扩展名.xsl,.xslx,且不超过50M(<span style="color:red">*EXCEL中的MSISDN列单元格为空,视为空行</span>)
                </el-col>
                <el-col :span="12" style="text-align:right">
                    {{addForm.choiceFilename}}
                </el-col>
            </div>
        </el-form-item>
        <el-form-item label="" v-show="addForm.stepsIsShow">
            <el-steps :active="addForm.stepNo" :center="true">
                <el-step title="检测模板文件" icon="el-icon-circle-check"></el-step>
                <el-step title="检测数据一致性" icon="el-icon-circle-check"></el-step>
                <el-step title="正在导入" icon="el-icon-circle-check"></el-step>
                <el-step title="导入完成" icon="el-icon-circle-check"></el-step>
            </el-steps>
        </el-form-item>
        <el-form-item label="" v-show="addForm.progressIsShow">
            <el-progress :text-inside="true" :stroke-width="12" :percentage="addForm.progressNo"></el-progress>
        </el-form-item>
        <el-form-item label="" v-show="addForm.errtextIsShow">
            <el-input type="textarea" :rows="4" :readonly="true" resize="none" placeholder="" v-model="addForm.errtextarea">
            </el-input>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-col :span="12" style="text-align:left;margin-bottom:15px;">
            <el-button icon="el-icon-download" @click.native="downImpExcel">下载模板</el-button>
        </el-col>
        <el-col :span="12" style="text-align:right;margin-bottom:15px;">
            <el-button @click.native="resetForm('addForm')">重置</el-button>
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">导入</el-button>
        </el-col>
    </div>
    <cardqrcode ref="cardqrcode" style="padding-left:0px"></cardqrcode>
</div>
</template>

<script>
import util from '../../common/js/util';
import CardQrcode from '../../components/bath_qrcode.vue';
import {
    bathRecharge,
    getAllchargeInfo,
    getrechargePrice,
    updateRechargeMoney
} from '../../api/api';
export default {
    components: {
        cardqrcode: CardQrcode
    },
    data() {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return false;
                }
            },
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            isrecharge: false, //批量入库界面是否显示
            addLoading: false,
            listLoading: false,
            rechargemonth: '12',
            options_month: [],
            //批量入库界面数据
            addForm: {
                fileList: [],
                stepsIsShow: true,
                stepNo: 0,
                progressIsShow: false,
                progressNo: 0,
                errtextIsShow: false,
                errtextarea: '',
                imp_syn_checked: true,
                cardXls: '',
                choiceFilename: ''
            },
            bathRechargeInfo: [

                // {
                //     "msisdn": "1064866876729",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "物联网流量卡-10元70M",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "1064866876729",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "物联网流量卡-10元70M",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "14764784041",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "sdfdsf",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "14764784041",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "sdfdsf",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "14764784041",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "sdfdsf",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "14764784041",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "sdfdsf",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "345345",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "sdfdsf",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "14764784041",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "sdfdsf",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "14764784041",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "sdfdsf",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // },
                // {
                //     "msisdn": "14764784041",
                //     "iccid": "898602F9161830015768",
                //     "packagename": "sdfdsf",
                //     "rechargePrice": "3.0",
                //     "arreas": "3.0",
                //     "money": "3.0",
                //     "expireTime": "2021-05-01",
                //     "rechargeExpireTime": "2022-05-01"
                // }

            ],
            rechargePrice: 0,
            orderId: 0
        }
    },
    methods: {
        //显示批量激活界面
        showBatchActive(val) {
            this.addForm = {
                fileList: [],
                stepsIsShow: true,
                stepNo: 0,
                progressIsShow: false,
                progressNo: 0,
                errtextIsShow: false,
                errtextarea: '',
                imp_syn_checked: true,
                inSkuTime: new Date(),
                cardXls: '',
                choiceFilename: ''
            };
            this.addFormVisible = true;
        },
        downImpExcel() {
            location.href = "/批量充值模板.xlsx";
        },
        //点击按钮触发选择EXCEL文件
        choiseFile() {
            this.$refs.excelFileHook.click();
        },
        //真正的选择EXCEL事件
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.addForm.cardXls = files[0];
            this.addForm.choiceFilename = "已选择文件【" + this.addForm.cardXls.name + "】";
        },
        beforeUploadValid(file) {
            this.addForm.stepsIsShow = true;
            this.addForm.stepNo = 1;
            this.addForm.progressIsShow = true;
            this.addForm.progressNo = 20;

            var fileType = file.name.substring(file.name.lastIndexOf("."), file.name.length)
            fileType = fileType.toLowerCase();
            //文件格式
            const isExcel = (fileType === '.xls') || (fileType === '.xlsx');
            //文件大小
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isExcel) {
                this.addForm.errtextIsShow = true;
                this.addForm.errtextarea = '上传文件扩展名只能是 xls/xlsx 格式!';
                return isExcel && isLt2M;
            }
            if (!isLt2M) {
                this.addForm.errtextIsShow = true;
                this.addForm.errtextarea = '上传文件大小不能超过 50MB!';
                return isExcel && isLt2M;
            }
            this.addForm.stepNo = 2;
            this.addForm.progressNo = 40;
            return isExcel && isLt2M;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.addForm.choiceFilename = '';
            this.addForm.cardXls = '';
            //clearFiles

            this.addForm.errtextIsShow = false;
            //this.addForm.stepsIsShow=false;
            this.addForm.progressIsShow = false;
            this.addForm.stepNo = 0;
            this.addForm.progressNo = 0;
        },
        //新增
        addSubmit: function () {

            if ('' == this.addForm.cardXls) {
                this.$message({
                    message: '请选择要求的EXCEL模板数据文件！',
                    type: 'error'
                });
                return;
            }
            
            this.addForm.stepsIsShow = true;
            this.addForm.progressIsShow = true;
            this.addForm.errtextIsShow = true;
            //先校验选择的文件格式和文件大小是否合格
            if (!this.beforeUploadValid(this.addForm.cardXls)) {
                return;
            }

            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    //this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.addLoading = true;
                    //NProgress.start();

                    var excelForm = new FormData();
                    excelForm.append("importXls", this.addForm.cardXls);

                    bathRecharge(excelForm).then((res) => {
                        this.addLoading = false;
                        //NProgress.done();
                        let {
                            msg,
                            code,
                            data
                        } = res;
                        if (code !== 0) {
                            this.addForm.stepNo = 2;
                            this.addForm.progressNo = 50;
                            this.addForm.errtextarea = msg;
                        } else {
                            this.$message({
                                message: msg,
                                type: 'success'
                            });
                            this.addForm.stepNo = 4;
                            this.addForm.progressNo = 100;
                            this.$refs['addForm'].resetFields();
                            this.addFormVisible = false;

                            this.addForm.errtextarea = msg;
                            this.orderId = data;
                            this.rechargemonth = '12';
                            //展示列表信息
                            this.isrecharge = true;
                            this.getrecharge();
                            //计算最终要充值的金额
                            this.getTotalAndOrderId();
                        }

                    });
                    //});
                }
            });

        },
        getrecharge() {

            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                orderid: this.orderId
            };
            this.listLoading = true;
            getAllchargeInfo(para).then((res) => {
                this.total = res.data.total;
                this.bathRechargeInfo = res.data.list;
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getrecharge();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getrecharge();
        },
        toRecharge() {
            if (this.rechargePrice <= 0) {
                this.$message({
                    message: '充值总金额为0，不能充值,请核实',
                    type: 'error'
                });
                return;
            }
            if(this.rechargemonth == null || this.rechargemonth == ''){
                this.$message({
                    message: '请选择选择续费周期！',
                    type: 'error'
                });
                return;
            }
            // var tishi="本次共充值"：+this.total}+张，总金额：<span style="color:red">{{this.rechargePrice}}</span>元
            this.isrecharge = false;
            this.$refs.cardqrcode.showCardQrcode(this.orderId, this.rechargePrice, this.total);
        },
        getTotalAndOrderId() {
            //获取总金额和订单编号
            let para = {
                orderid: this.orderId
            }
            getrechargePrice(para).then((res) => {
                this.rechargePrice = res.data.rechargePrice;
                //this.orderId = res.data.orderId;
            });
        },
        exportRechage() {
            let para = "";
            para += "orderid=" + this.orderId;

            location.href = "/api/tRechargeTemp/exportXls?"+para;
        },
        rechargemonthchange(){
            let para = {
                orderid: this.orderId,
                rechargemonth: this.rechargemonth
            }
            updateRechargeMoney(para).then((res) => {
                this.getTotalAndOrderId();
                this.getrecharge();
            });
        }
    },
    mounted() {
        this.options_month = [];
        for(var i=1;i<=13;i++){
            let month = {
                "label": i + "个月",
                "value": i + ''
            }
            this.options_month.push(month);
        }
        let month_24 = {
            "label": "24个月",
            "value": '24'
        }
        this.options_month.push(month_24);
        let month_36 = {
            "label": "36个月",
            "value": '36'
        }
        this.options_month.push(month_36);

        //     this.$refs.cardqrcode.showCardQrcode('1001',20.5,21);
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// batch_recharge.vue?d90411c0